import {view, Icon} from '@sail/ui';
import {arrowLeft} from '@sail/icons/react/Icon';

interface BackButtonProps {
  onBack: () => void;
}

export const BackButton = ({onBack}: BackButtonProps) => {
  return (
    <view.button
      onClick={onBack}
      aria-label="Go back"
      css={{
        stack: 'y',
        backgroundColor: 'transparent',
        border: 'none',
        padding: 'space.0',
        cursor: 'pointer',
        alignItems: 'center',
      }}
    >
      <Icon icon={arrowLeft} />
    </view.button>
  );
};
